import React from 'react';
import './QuiSuisJe.scss';
import image from '../../assets/IMG_0645.webp';

/**
 * Page de présentation du parcours et de la philosophie de Marie Guennec.
 */
const QuiSuisJe = () => {
  return (
    <div className="qui-suis-je-page container">
      <header className="page-header">
        <h1>Psychologue clinicienne et neuropsychologue à Bouaye</h1>
      </header>

      <section className="profile-section">
        <div className="profile-image-wrapper">
          <img 
            src={image} 
            alt="Marie Guennec - Neuropsychologue" 
          />
        </div>

        <div className="profile-content">
          <p className="lead-text">
            Diplômée d’un <strong>Master de Neuropsychologie Clinique et Intégrative</strong> de 
            l’Université de Picardie Jules Verne à Amiens, je suis spécialisée dans l'évaluation du 
            fonctionnement cognitif et l'accompagnement psychologique des adolescents, des adultes et des personnes âgées.
          </p>

          <p>
            Mon parcours m'a amenée à exercer au sein de différentes structures de soins, notamment en 
            neurologie, gériatrie, réadaptation et santé mentale. J'y ai accompagné des personnes présentant 
            des troubles neurologiques, des troubles psychiques, des douleurs chroniques ainsi que des 
            difficultés cognitives, attentionnelles ou mnésiques.
          </p>

          <p>
            Au cours de ces expériences, j'ai réalisé de nombreux bilans neuropsychologiques, assuré des 
            suivis psychologiques et participé à l'accompagnement des proches aidants. Cette diversité de 
            pratiques me permet aujourd'hui de proposer une prise en charge globale, individualisée et 
            centrée sur la singularité de chacun.
          </p>

          <p>
            Je suis particulièrement attachée à offrir un espace d'écoute bienveillant et de confiance, 
            où chacun peut être accueilli avec ses questionnements, ses difficultés et ses ressources. 
            Mon objectif est de mieux comprendre votre fonctionnement, de mettre en lumière vos points d'appui 
            et de vous accompagner vers des solutions adaptées à votre situation.
          </p>

          <p className="highlight-text">
            Je suis convaincue qu'une meilleure compréhension de soi constitue souvent une première 
            étape essentielle pour avancer plus sereinement dans son quotidien.
          </p>

          <div className="legal-numbers">
            <div className="number-tag">
              <span>Numéro SIRET :</span> 10652408500011
            </div>
            <div className="number-tag">
              <span>Numéro RPPS :</span> 10111251236
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuiSuisJe;